import { render, staticRenderFns } from "./DashboardQuickAccess.vue?vue&type=template&id=3e114378&scoped=true"
import script from "./DashboardQuickAccess.vue?vue&type=script&lang=js"
export * from "./DashboardQuickAccess.vue?vue&type=script&lang=js"
import style0 from "./DashboardQuickAccess.vue?vue&type=style&index=0&id=3e114378&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e114378",
  null
  
)

export default component.exports